import { render, staticRenderFns } from "./search-open-contact-requests.vue?vue&type=template&id=2be1293f&scoped=true&"
import script from "./search-open-contact-requests.vue?vue&type=script&lang=js&"
export * from "./search-open-contact-requests.vue?vue&type=script&lang=js&"
import style0 from "./search-open-contact-requests.vue?vue&type=style&index=0&id=2be1293f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be1293f",
  null
  
)

export default component.exports